import { render, staticRenderFns } from "./TabbarComponent.vue?vue&type=template&id=55024442&scoped=true&"
import script from "./TabbarComponent.vue?vue&type=script&lang=js&"
export * from "./TabbarComponent.vue?vue&type=script&lang=js&"
import style0 from "./TabbarComponent.vue?vue&type=style&index=0&id=55024442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55024442",
  null
  
)

export default component.exports